import { createContext } from 'react'

import type { IContentFiltersContext } from './content-filters.types'

const CONTENT_FILTERS_FALLBACK: IContentFiltersContext = {
  territoryContentFilters: undefined,
  territoryIds: null,
  loading: false,
}

export const ContentFiltersContext = createContext<IContentFiltersContext>(CONTENT_FILTERS_FALLBACK)
